import logErrors from '@nykaa/logger/logErrors';
import { ApiHelper } from 'shared/api';
import { SEARCH_PROXY_PREFIX } from 'shared/constants/urls';
import { ROUTES, urls, getUrlPrefixed } from 'shared/api/urls';
import { statusMessages } from 'shared/constants/statusCodes';
import { logger } from 'logging';
import { deviceTypes } from 'shared/constants';
import { queryStringFromParams } from 'shared/helpers/utils/url';
import { transformSearchListingData, transformPageData } from './transformers';
import { transformEddFilterList } from 'store/categoryListing/transformer';

const MANDATORY_REQUEST_PARAMS = {
  app_version: 7003,
  filter_format: 'v2',
  source: 'react',
};

const deviceType = {
  deviceType: deviceTypes.M_SITE,
  platform: deviceTypes.M_SITE,
};

const ERROR_MESSAGE_TEMPLATE = 'Error fetching Search Listing products';
const SEARCH_INTERNAL_DOMAIN = process.env.SEARCH_INTERNAL;
const ERROR_FETCHING_EDD_LIST = 'Error fetching EDD filter list';

export const getSearchProducts = async (
  params: any,
  pageFetch: boolean = false
): Promise<any> => {
  const url = getUrlPrefixed(
    urls[ROUTES.SEARCH_LISTING],
    SEARCH_PROXY_PREFIX,
    SEARCH_INTERNAL_DOMAIN
  );

  const requestParams = {
    ...MANDATORY_REQUEST_PARAMS,
    ...params,
    ...deviceType,
    show_searchable_child: true,
  };

  const queryString = queryStringFromParams(requestParams);

  try {
    const requestUrl = `${url}${queryString}`;
    const {
      data: { response, status },
    } = await ApiHelper(requestUrl);

    if (status === statusMessages.SUCCESS) {
      if (pageFetch) {
        return transformPageData(response);
      }
      const transformedResponse = await transformSearchListingData(response);
      return transformedResponse;
    }

    throw new Error(`${status}: ${ERROR_MESSAGE_TEMPLATE}`);
  } catch (error) {
    const errorMessage = ERROR_MESSAGE_TEMPLATE;
    if (__SERVER__) {
      logger.error(error, errorMessage);
    } else {
      logErrors(error, errorMessage);
    }

    throw error;
  }
};

export const getEDDFilter = async (params: any) => {
  const url = getUrlPrefixed(
    urls[ROUTES.SLP_EDD_FILTER_LIST],
    SEARCH_PROXY_PREFIX,
    SEARCH_INTERNAL_DOMAIN
  );

  const requestParams = {
    ...MANDATORY_REQUEST_PARAMS,
    ...params,
    ...deviceType,
  };

  const queryString = queryStringFromParams(requestParams);
  try {
    const {
      data: { response },
    } = await ApiHelper(`${url}${queryString}`, 'get');
    if (!response) {
      throw new Error('"response" not found edd list api -> data');
    }
    const transformList = transformEddFilterList(response);
    return transformList;
  } catch (e) {
    logErrors(e, `${ERROR_FETCHING_EDD_LIST} :url=${url}`);
    throw e;
  }
};
